/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NaturePlantTreeFirIcon20Solid = forwardRef('NaturePlantTreeFirIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M11.327 1.644a1.75 1.75 0 0 0-2.654 0L2.778 8.503A.906.906 0 0 0 3.465 10h1.963l-3.896 4.495a.906.906 0 0 0 .685 1.5H8.75v2.755a1.25 1.25 0 1 0 2.5 0v-2.755h6.533a.906.906 0 0 0 .685-1.5L14.572 10h1.963a.906.906 0 0 0 .687-1.497l-5.895-6.86Z" })));
});
